<div
  class="repeater-section o2mSection"
  [class.o2m-compact]="showCompactDisplay"
  [class.o2m-expanded]="!showCompactDisplay"
>
  @if (showCompactDisplay) {
    <!-- Compact display row for saved items -->
    <div class="o2m-compact-row">
      <div class="o2m-compact-icon"></div>
      <div class="o2m-compact-content">
        @for (lf of listingFields; track lf; let first = $first) {
          @if (getFieldValue(lf)) {
            @if (!first) {
              <span class="o2m-compact-separator">&middot;</span>
            }
            @if (first) {
              <span
                class="o2m-compact-primary"
                (click)="triggerSplitSearch(lf)"
                [style.cursor]="
                  dfms?.isFormReadOnly == true ? 'pointer' : 'default'
                "
                >
                @if (lf.DataType == "StringLink") {
                  <a
                    class="o2m-string-link"
                    [href]="getLinkHref(getFieldValue(lf))"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                    >{{ getFieldValue(lf) }}</a
                  >
                } @else {
                  {{ getFieldValue(lf) }}
                }
              </span>
            }
            @if (!first) {
              <span
                class="o2m-compact-field"
                (click)="triggerSplitSearch(lf)"
                [style.cursor]="
                  dfms?.isFormReadOnly == true ? 'pointer' : 'default'
                "
              >
                <span class="o2m-compact-label"
                  >{{ translationsService.translate(lf.Name) }}:</span
                >
                @if (lf.DataType == "StringLink") {
                  <a
                    class="o2m-string-link"
                    [href]="getLinkHref(getFieldValue(lf))"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                    >{{ getFieldValue(lf) }}</a
                  >
                } @else {
                  {{ getFieldValue(lf) }}
                }
              </span>
            }
          }
        }
      </div>
      <div class="o2m-compact-actions">
        @if (
          !checkForDisabled(bindingPropertyName) && dfms?.isFormReadOnly != true
        ) {
          <button
            type="button"
            class="o2m-action-btn o2m-edit-btn"
            (click)="startEdit(); $event.stopPropagation()"
          ></button>
          @if (!deleteDisabled) {
            <button
              type="button"
              class="o2m-action-btn o2m-delete-btn"
              (click)="removeSection(section); $event.stopPropagation()"
            ></button>
          }
        }
      </div>
    </div>
  } @else {
    <!-- Full edit mode (existing behavior) -->
    @if (
      !checkForDisabled(bindingPropertyName) &&
      !isInline &&
      dfms?.isFormReadOnly != true
    ) {
      <div
        class="manipulate-section inner-manipulate-section o2m-section-additional-actions"
        (click)="toggleDD()"
      >
        <span class="tooltip-text o2m-additional-actions-tooltip">{{
          translationsService.translate(
            "galis_js_o2m_tooltip_additional_actions"
          )
        }}</span>
      </div>
    }

    @if (showRepeaterActions() == true) {
      <div>
        @if (!checkForDisabled(bindingPropertyName) && showDD && !isInline) {
          <div class="sem-dropdown">
            @for (action of actions; track action) {
              <div>
                @if (
                  evaluateCondition(action.Condition) ||
                  action.Condition == null
                ) {
                  <div
                    (click)="evaluateSectionAction(action)"
                    class="dd-section"
                  >
                    <p class="repeater-text">
                      {{
                        this.translationsService.translate(action.ActionName)
                      }}
                    </p>
                  </div>
                }
              </div>
            }
            @if (!deleteDisabled) {
              <div>
                <div (click)="removeSection(section)" class="dd-section">
                  <p class="repeater-text">
                    {{ this.translationsService.translate("Delete") }}
                  </p>
                </div>
              </div>
            }
            @if (orderEnabled) {
              <div class="o2m-order" (click)="up()">
                <img
                  src="/assets/css/images/platform/dd-table-up@3x.png"
                  class="zoom-in-icon"
                />
              </div>
            }
            @if (orderEnabled) {
              <div class="o2m-order" (click)="down()">
                <img
                  src="/assets/css/images/platform/dd-table-down@3x.png"
                  class="zoom-in-icon"
                />
              </div>
            }
          </div>
        }
      </div>
    }

    <app-sem-dynamic-control
      [forwardEntities]="forwardEntities"
      [forwardEntityName]="forwardEntityName"
      [bindingPropertyName]="bindingPropertyName"
      #dynComp
      [number]="number"
      (sectionAction)="sectionActionFired()"
      (ngModelChange)="modelChanged($event)"
      [entity]="section"
      [template]="contentTemplate"
      [url]="nestedRenderUrl"
    ></app-sem-dynamic-control>

    @if (listingFields && listingFields.length > 0 && !isInline) {
      <div class="o2m-edit-actions">
        @if (isNewItem && !isAddConfirmed) {
          <button
            type="button"
            class="o2m-cancel-btn"
            (click)="removeSection(section)"
          >
            Prekliči
          </button>
          <button type="button" class="o2m-add-btn" (click)="confirmAdd()">
            Dodaj ✓
          </button>
        } @else if (isEditing) {
          <button type="button" class="o2m-cancel-btn" (click)="cancelEdit()">
            Prekliči
          </button>
        }
      </div>
    }
  }
</div>
